// typescript
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
    // If there's a cached token, allow; otherwise attempt to get token silently
    const cached = await this.auth.getDecodedCachedToken();
    if (cached) {
      return true;
    }
    const token = await this.auth.getAccessToken();
    if (token) {
      return true;
    }
    // If getAccessToken redirected the app, this code may not run; otherwise redirect to root
    return this.router.parseUrl('/');
  }
}